import { ReactComponent as SpainFlag } from 'assets/page-header/spain-flag.svg';
import { ReactComponent as USFlag } from 'assets/page-header/us-flag.svg';
import { useState, useContext } from 'react';
import { LanguageContext } from 'context/language-context';

const lstLanguages = [
  { name: 'English', Flag: () => <USFlag height={24} width={24} />, lang: 'en' },
  { name: 'Spanish', Flag: () => <SpainFlag />, lang: 'es' },
];
const TranslatorDropdown = () => {
  const { lang, onLanguageChange } = useContext(LanguageContext);
  const [showLang, setShowLang] = useState<boolean>(false);
  const getSelectLangFlag = () => {
    switch (lang) {
      case 'es':
        return <SpainFlag height={32} width={32} className="flex items-center justify-center" />;
      case 'en':
        return <USFlag />;
    }
  };
  return (
    <div
      className="flex items-center justify-center relative mr-2"
      tabIndex={0}
      onBlur={e => {
        e.preventDefault();
        if (!e.currentTarget.contains(e.relatedTarget)) {
          setShowLang(false);
        }
      }}
    >
      <div
        className="flex items-center justify-center h-9 w-9 rounded-full border-1 border-divider2 bg-bg-50 cursor-pointer"
        onClick={() => setShowLang(!showLang)}
      >
        <div className="flex items-center justify-center">{getSelectLangFlag()}</div>
      </div>
      {showLang && (
        <div className="flex absolute top-10 -right-2">
          <div className="flex flex-col justify-start items-start w-[150px] max-h-[calc(100vh-66px)] h-fit rounded-2 overflow-hidden z-10 bg-white">
            {lstLanguages.map(data => (
              <div
                className="flex items-center px-4 py-2 border-b-1 border-grey w-full gap-x-2 cursor-pointer hover:bg-grey4"
                onClick={() => {
                  if (onLanguageChange) onLanguageChange(data.lang);
                  setShowLang(false);
                }}
              >
                <div className="flex items-center justify-center border-1 rounded-full h-6 w-6 cursor-pointer">
                  {data.Flag()}
                </div>
                <label className="text-sm font-medium cursor-pointer">{data?.name}</label>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default TranslatorDropdown;
